var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_11308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9835 24.4106H50.6445V51.4406H10.9835V24.4106Z",
    fill: "#40596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8137 0.44043L61.3223 12.5529V24.4105H0.305312V12.5529L30.8137 0.44043Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.305313 56.5405H61.3223V61.6405H0.305313V56.5405Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22921 51.3125H58.5259V56.4125H3.22921V51.3125Z",
    fill: "#CDD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7886 24.4106H15.0513V28.7457H6.7886V24.4106Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7886 47.1055H15.0513V51.4405H6.7886V47.1055Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93232 28.6182H14.1611V46.9781H7.93232V28.6182Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1358 24.4106H28.3984V28.7457H20.1358V24.4106Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1358 47.1055H28.3984V51.4405H20.1358V47.1055Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.28 28.6182H27.5088V46.9781H21.28V28.6182Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4492 24.4106H54.7119V28.7457H46.4492V24.4106Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4492 47.1055H54.7119V51.4405H46.4492V47.1055Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5934 28.6182H53.8223V46.9781H47.5934V28.6182Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.229 24.4106H41.4917V28.7457H33.229V24.4106Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.229 47.1055H41.4917V51.4405H33.229V47.1055Z",
    fill: "#ACB3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2463 28.6182H40.4751V46.9781H34.2463V28.6182Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4492 24.4106H54.7119V25.9407H46.4492V24.4106Z",
    fill: "#A0ABB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.229 24.4106H41.4917V25.9407H33.229V24.4106Z",
    fill: "#A0ABB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1358 24.4106H28.3984V25.9407H20.1358V24.4106Z",
    fill: "#A0ABB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78811 24.4106H15.0508V25.9407H6.78811V24.4106Z",
    fill: "#A0ABB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8137 19.5652C28.0054 19.5652 25.7289 17.2819 25.7289 14.4652C25.7289 11.6486 28.0054 9.36523 30.8137 9.36523C33.6219 9.36523 35.8984 11.6486 35.8984 14.4652C35.8984 17.2819 33.6219 19.5652 30.8137 19.5652Z",
    fill: "#ACB3BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_11308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.017,
    height: 61.2,
    fill: "white",
    transform: "matrix(-1 0 0 1 61.3223 0.44043)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIllustration);
export default __webpack_public_path__ + "static/media/bank-illustration.37d4bf0ae1f53a391ca40f09af118a85.svg";
export { ForwardRef as ReactComponent };